export const defaultTenant = "Vistaprint";
export const LOGO_CHARGE_TENANTS = new Set(["national-pen"]);
